import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

type Status = "hot" | "new" | "keeping" | "applied" | "considering" | "browsing";

const StatusText: Record<Status, string> = {
  hot: "HOT",
  new: "NEW",
  keeping: "キープ中",
  applied: "応募済み",
  considering: "応募画面到達",
  browsing: "求人閲覧済",
};

type Props = {
  status: Status;
};

export const ScoutStatusLabel: FC<Props> = ({ status }) => (
  <span className={styles.outer}>
    {status === "hot" && (
      <span className={styles.iconOuter}>
        <Icon name="fire" />
      </span>
    )}
    <span className={styles.label({ status })}>{StatusText[status]}</span>
  </span>
);
